import PropTypes from "prop-types";
import React from "react";

class DisplayMedia extends React.Component {
  render() {
    var attachments = this.props.attachments;
    var postMedia = "";
    attachments.forEach(attachment => {
      var mediaType = attachment.type;
      console.log("MEDIA TYPE: ", mediaType);

      if (mediaType === "photo") {
        var imageUrl = attachment.media.image.src;
        postMedia = <img src={imageUrl} alt={attachment.title} />;
      }
    });

    return <div className="media">{postMedia}</div>;
  }
}

DisplayMedia.propTypes = {
  attachments: PropTypes.array
};

export default DisplayMedia;
